import styled from 'styled-components';

export const TableContainer = styled.div<{ maxHeight?: number }>`
  position: relative;
  border: ${({ theme }) => `${theme.lineWidth}px solid ${theme.colorBorder}`};
  border-radius: ${({ theme }) => theme.borderRadius}px;
  overflow: hidden;
  background: ${({ theme }) => theme.colorBgContainer};
`;

export const TableWrapper = styled.div<{
  maxHeight?: number;
  scrollable?: boolean;
}>`
  ${({ maxHeight, scrollable }) =>
    scrollable && maxHeight
      ? `max-height: ${maxHeight}px; overflow: auto;`
      : ''}

  /* Custom scrollbar styling following theme */
  &::-webkit-scrollbar {
    width: ${({ theme }) => theme.sizeXS}px;
    height: ${({ theme }) => theme.sizeXS}px;
  }

  &::-webkit-scrollbar-track {
    background: ${({ theme }) => theme.colorFillQuaternary};
  }

  &::-webkit-scrollbar-thumb {
    background: ${({ theme }) => theme.colorFillSecondary};
    border-radius: ${({ theme }) => theme.borderRadiusXS}px;

    &:hover {
      background: ${({ theme }) => theme.colorFillContent};
    }
  }

  /* Firefox scrollbar styling */
  scrollbar-width: thin;
  scrollbar-color: ${({ theme }) =>
    `${theme.colorFillSecondary} ${theme.colorFillQuaternary}`};
`;

export const ScrollShadowTop = styled.div<{ visible: boolean }>`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: ${({ theme }) => theme.sizeXS}px;
  background: linear-gradient(
    to bottom,
    ${({ theme }) => theme.colorBgContainer},
    transparent
  );
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity ${({ theme }) => theme.motionDurationMid}
    ${({ theme }) => theme.motionEaseInOut};
  pointer-events: none;
  z-index: ${({ theme }) => theme.zIndexPopupBase - 1};
`;

export const ScrollShadowBottom = styled.div<{ visible: boolean }>`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: ${({ theme }) => theme.sizeXS}px;
  background: linear-gradient(
    to top,
    ${({ theme }) => theme.colorBgContainer},
    transparent
  );
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  transition: opacity ${({ theme }) => theme.motionDurationMid}
    ${({ theme }) => theme.motionEaseInOut};
  pointer-events: none;
  z-index: ${({ theme }) => theme.zIndexPopupBase - 1};
`;
